import TagGroup from './TagGroup';

// export types
export type { TagGroupProps } from './TagGroup';

// export components
export { TagGroup };
export default TagGroup;
